'use client';

import { c as _c } from "react/compiler-runtime";
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';
import { flagsContext } from '@/contexts/flagsContext';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';
export const LaunchDarklyProvider = props => {
  const $ = _c(29);
  const {
    isDev,
    isDemo,
    isTest,
    launchDarklyClientId
  } = useEnvironment();
  const {
    currentProjectId,
    user
  } = useUser();
  if (!currentProjectId) {
    return props.children;
  }
  if (isDemo || isDev || isTest) {
    const t0 = !isDemo;
    const t1 = isDev || isDemo;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        view: true,
        trend: true,
        export: true,
        audit: false
      };
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] !== isDev || $[2] !== t0 || $[3] !== t1) {
      t3 = {
        NonCognitoEonAccounts: false,
        SkipOnboarding: false,
        dlsgFrontend: false,
        LlgFrontend: false,
        InventoryStatusColumns: isDev,
        AwsDiscoveryRegionAllowlist: true,
        GcpPermissionGroupEnforcement: true,
        GcpDiscoveryServicePicker: false,
        enableHourlyBackup: false,
        AzureSqlVirtualMachineSupport: true,
        AzureSqlManagedInstanceSupport: true,
        MySqlFlexibleServerSupport: true,
        ownCustomerOnboardingEnabled: false,
        hourlyDlsgPolicyEnabled: false,
        SecurityFindings: true,
        AllowAccountLevelSamlWhenOrgAttached: false,
        InventoryFilterOmnibox: true,
        EnableGDSGPage: isDev,
        EnableGdsgNotifications: false,
        StorageGatewayCostExplorer: isDev,
        CostExplorerUsdToOtherCurrencies: isDev,
        EnableGdsgObjectActions: isDev,
        EnableGdsgInventoryReports: isDev,
        SupportColdTierVaults: true,
        AiAssistantSidebar: isDev,
        SapHanaPitrSupport: true,
        MongoAtlasSupport: true,
        MongoAtlasNonAwsClusters: isDev,
        MongoAtlasAdvancedRestoreEnabled: isDev,
        GcpSqlVirtualMachineSupport: true,
        ExploreFilesForDatabaseVms: true,
        RdsRestoreWithoutEncryptionEnabled: false,
        RecordRestoreResultsEnabled: true,
        GcpVmHighFrequencyBackupEnabled: true,
        RdsHighFrequencyBackupEnabled: true,
        EnableCrossCloudKvRecordRestore: true,
        EnableCrossCloudKvRecordRestoreAzure: true,
        AzureSnapshotsDiscoverySupport: true,
        AzureAdeBackupSupport: true,
        AzureVmDesRestoreSupport: true,
        AzureMssqlTdeCmkRestore: true,
        AwsRdsNativeBackupSupport: true,
        ShadowClassificationPolicy: true,
        AwsEksClusterBackupSupport: true,
        AzureMultipleAppRegistrations: false,
        AzureCustomPermissionsModel: false,
        GoogleWorkspaceSupport: true,
        GoogleWorkspaceEnableRansomwareDetection: true,
        GwsInPlaceRestoreOnly: false,
        GwsRestoreToTargetMailbox: true,
        GwsRestoreToTargetDrive: true,
        GwsRestoreWholeSharedDrive: true,
        Microsoft365Support: true,
        Microsoft365RestoreSupport: true,
        EnableRansomwareDetectionM365: true,
        M365TeamsSupport: true,
        M365TeamsChatsSupport: t0,
        M365RestoreToAnotherUser: true,
        EntraIdSupport: true,
        EntraIdApplicationEstate: false,
        EntraIdAdministrativeUnits: false,
        UnifiedSearch: t1,
        EnableMrapForByov: true,
        BigQueryNativeRestoreEnabled: true,
        EnableBigQueryNativePolicy: true,
        GcpProjectLabelTagFilterEnabled: true,
        CancelBackupJobEnabled: true,
        BigQueryRestoreOverwriteEnabled: true,
        SensitivityAnnotations: true,
        EnableNetworkClassification: true,
        RdsRestorePreserveOriginalMemberNames: false,
        CassandraSupport: true,
        DataPlatformConsoleEnabled: true,
        DataEngineDefaultLanding: false,
        RdsCdcUiEnabled: true,
        LakehouseMetricExportEnabled: true,
        RolePermissionFamiliesEnabled: true,
        UnifiedIdentityRestore: true,
        AiAgents: isDev,
        AiDashboardsSupport: isDev,
        ZeroEtlEnabled: true,
        LakehouseEnabled: false,
        ZeroEtlMultiResourcePolicies: false,
        ZeroEtlBackupPolicyLink: true,
        ZeroEtlIntegrationsEnabled: true,
        DataKnowledgeGraphEnabled: false,
        AgenticDataLayerEnabled: false,
        LakehouseCustomerOwnedCatalogs: false,
        StreamlakeLakehouseScreens: true,
        StreamlakePipelineCostChartsEnabled: isDev,
        StreamlakePipelineStorageAPICostChartsEnabled: false,
        EnableExportAccessDeniedItems: true,
        InventoryIssuesColumn: false,
        RestoreTemplates: true,
        BulkRestore: true,
        EnableYaraScan: true,
        RemediationOrchestration: true,
        EnableInventoryEntitiesFilter: true,
        DataClassificationCredentialsEnabled: false,
        SaasInventoryDefaultLanding: false,
        BackupComplianceJson: t2,
        EnableSnapshotArchitect: true,
        UseTargetVpcForRestoreServer: true,
        UseTargetVpcForFileRestoreServer: true,
        EnableGcpInstantRestore: true,
        EnableShovalAgentInstallUi: true
      };
      $[1] = isDev;
      $[2] = t0;
      $[3] = t1;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {};
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t3) {
      t5 = {
        flags: t3,
        flagKeyMap: t4,
        ldClient: undefined
      };
      $[6] = t3;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== props.children || $[9] !== t5) {
      t6 = <flagsContext.Provider value={t5}>{props.children}</flagsContext.Provider>;
      $[8] = props.children;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  if (!launchDarklyClientId || !user?.eonAccount) {
    return props.children;
  }
  let t0;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      reactContext: flagsContext,
      useCamelCaseFlagKeys: false
    };
    $[11] = t0;
  } else {
    t0 = $[11];
  }
  let t1;
  if ($[12] !== currentProjectId || $[13] !== user.eonAccount.domain || $[14] !== user.eonAccount.name) {
    t1 = {
      key: currentProjectId,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain
    };
    $[12] = currentProjectId;
    $[13] = user.eonAccount.domain;
    $[14] = user.eonAccount.name;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  let t2;
  if ($[16] !== currentProjectId || $[17] !== user.eonAccount.domain || $[18] !== user.eonAccount.id || $[19] !== user.eonAccount.name) {
    t2 = {
      key: user.eonAccount.id,
      name: user.eonAccount.name,
      domain: user.eonAccount.domain,
      projectId: currentProjectId
    };
    $[16] = currentProjectId;
    $[17] = user.eonAccount.domain;
    $[18] = user.eonAccount.id;
    $[19] = user.eonAccount.name;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== t1 || $[22] !== t2) {
    t3 = {
      kind: "multi",
      user: t1,
      organization: t2
    };
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      streaming: false
    };
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== launchDarklyClientId || $[26] !== props.children || $[27] !== t3) {
    t5 = <LDProvider reactOptions={t0} clientSideID={launchDarklyClientId} timeout={2} context={t3} options={t4}>{props.children}</LDProvider>;
    $[25] = launchDarklyClientId;
    $[26] = props.children;
    $[27] = t3;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
};